module.exports = {"items":[{"value":"CSEY Advocacy","text":"CSEY Advocacy"},{"value":"Drop-In Center","text":"Drop-In Center"},{"value":"Emergency Shelter","text":"Emergency Shelter"},{"value":"Long Term Residential","text":"Long Term Residential"},{"value":"Prevention","text":"Prevention"},{"value":"Therapy/Counseling","text":"Therapy/Counseling"},{"value":"Other","text":"Other"}]}


//////////////////
// WEBPACK FOOTER
// ./src/store/data/programTypes.json
// module id = 1982
// module chunks = 0